import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n'
import App from './App.tsx'
import { logVersionInfo, getVersionInfo, APP_VERSION } from './lib/version'
import { reportWebVitals } from './lib/web-vitals'

// Log version info to console
logVersionInfo()

// Expose version info on window object for easy access
declare global {
  interface Window {
    __APP_VERSION__: string
    __APP_INFO__: ReturnType<typeof getVersionInfo>
  }
}

window.__APP_VERSION__ = APP_VERSION
window.__APP_INFO__ = getVersionInfo()

// Report web vitals
reportWebVitals()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
